import {PayloadStates} from '@lore/utils';
import useMissingFields from '@/pages/projects/useMissingFields';
import isProjectShareable from '@/features/share-project/utils/isProjectShareable';

// Same rules as the Share project button on the project card.
export default function useIsProjectShareable(project) {
  const {missingFields} = useMissingFields(project);

  const isIncomplete = (
    missingFields.state !== PayloadStates.RESOLVED ||
    missingFields.data.length > 0
  );

  return isProjectShareable(project.data, {isIncomplete});
}
